import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
    align-items: center;
    appearance: none;
    background-color: #39d38b;
    border-radius: ${props => props.borderRadius};
    border-width: 0;
    box-shadow: rgba(62,209,139,0.2) 0 2px 4px,rgba(62,209,139,0.15) 0 7px 13px -3px,rgba(62,209,139,0.7) 0 -3px 0 inset;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    height: 48px;
    justify-content: center;
    line-height: 1;
    list-style: none;
    overflow: hidden;
    position: relative;
    text-align: left;
    text-decoration: none;
    transition: box-shadow .15s,transform .15s;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    white-space: nowrap;
    will-change: box-shadow,transform;
    font-size: 18px;
    margin:${props => props.margin};
    width:${props => props.width};
    padding:${props => props.padding};
    &:focus{
        box-shadow: rgba(62,209,139,0.7) 0 0 0 1.5px inset, rgba(62,209,139,0.4) 0 2px 4px, rgba(62,209,139,0.3) 0 7px 13px -3px, rgba(62,209,139,0.7) 0 -3px 0 inset;
    }
    &:hover{
        box-shadow: rgba(62,209,139,0.3) 0 4px 8px, rgba(62,209,139,0.2) 0 7px 13px -3px, rgba(62,209,139,0.7) 0 -3px 0 inset;
        transform: translateY(-2px);
    }
    &:active{
        box-shadow: rgba(62,209,139,0.7) 0 3px 7px inset;
        transform: translateY(2px);
    }
    &:disabled{
        background-color: #dddddd;
        opacity: 0.5;
        pointer-events:none;
        box-shadow:none;
    }
`

StyledButton.defaultProps = {
    width:"max-content",
    borderRadius:"4px",
    padding:"1rem"
}

const SuccessButton = (props) => {
  return (
    <StyledButton  {...props} >{props.children}</StyledButton>
  )
}

export default SuccessButton;
